import _ from 'lodash';
import React from 'react';
import { Heading, LinkBlock, Text } from 'rebass';
import { Flex, Box } from 'reflexbox';
import { Link } from 'react-router';

import config from 'frontend/config';
import {
  DarkerBox,
} from 'frontend/components';

import RaidbotsSkull, { EXPRESSIONS } from 'frontend/components/RaidbotsSkull';
import SvgIcons from 'frontend/SvgIcons';

import News from './News';

const panels = [{
  title: 'Top Gear',
  link: '/simbot/topgear',
  icon: SvgIcons.optimize.large,
  description: 'Find the best gear and talents for your character',
}, {
  title: 'Droptimizer',
  link: '/simbot/droptimizer',
  icon: SvgIcons.die.large,
  description: 'Find your best drops',
}, {
  title: 'Quick Sim',
  link: '/simbot/quick',
  icon: SvgIcons.quick.large,
  description: 'Run a quick sim to get your DPS and detailed stats',
}, {
  title: 'Advanced',
  link: '/simbot/advanced',
  icon: SvgIcons.advanced.large,
  description: 'Run (almost) any raw SimulationCraft script',
}];

/*
const unusedPanels = [{
  title: 'Stat Weights',
  link: '/simbot/stats',
  icon: SvgIcons.stats.large,
  description: 'Generate stat weights for your character',
}, {
  title: 'Talent Compare',
  link: '/simbot/talents',
  icon: SvgIcons.talents.large,
  description: 'Compare different talent builds',
}, {
  title: 'Gear Compare',
  link: '/simbot/gear',
  icon: SvgIcons.gear.large,
  description: 'Compare different sets of gear',
}];
*/

const panelExpressions = _.reject(EXPRESSIONS, e => e === 'normal');

class SkullPanel extends React.Component {
  state = {
    size: 32,
    currentExpression: _.sample(panelExpressions),
  };

  onClick = () => {
    this.setState(prevState => ({
      size: prevState.size + 1,
      currentExpression: _.sample(_.reject(panelExpressions, e => e === prevState.currentExpression)),
    }));
  };

  render() {
    return (
      <RaidbotsSkull
        expression={this.state.currentExpression}
        size={this.state.size}
        onClick={this.onClick}
      />
    );
  }
}

const Home = () => (
  <Box>
    <Flex justify="center" my={2}>
      <Text style={{ fontSize: 24 }}>
        {/* eslint-disable react/jsx-no-target-blank */}
        Run <a href="http://simulationcraft.org/" target="_blank" rel="noopener">SimulationCraft</a> in the cloud
        to optimize your World of Warcraft character.
        {/* eslint-enable react/jsx-no-target-blank */}
      </Text>
    </Flex>
    <Flex justify="center">
      <Box col={12}>
        <Flex wrap gutter={2}>
          {panels.map(panel => (
            <Box
              lg={6}
              sm={12}
              key={panel.link}
            >
              <Box m={2}>
                <LinkBlock is={Link} to={panel.link} m={0} p={0} style={{ height: '100%' }}>
                  <DarkerBox
                    align="center"
                    style={{
                      margin: 0,
                      padding: 0,
                      border: '1px solid black',
                    }}
                  >
                    <Flex align="center" my={1} mx={1} p={0}>
                      <Box p={0}>
                        <panel.icon
                          style={{
                            width: 110,
                            height: 110,
                            fill: config.colors.orange,
                          }}
                        />
                      </Box>
                      <Box ml={1}>
                        <Heading level={2} color={config.colors.orange}>
                          {panel.title}
                        </Heading>
                        <Text bold style={{ fontWeight: 700 }}>
                          {panel.description}
                        </Text>
                      </Box>
                    </Flex>
                  </DarkerBox>
                </LinkBlock>
              </Box>
            </Box>
          ))}
          <Box lg={6} sm={12}>
            <Flex
              m={2}
              align="center"
              justify="center"
              style={{
                minHeight: 134,
                userSelect: 'none',
              }}
            >
              <SkullPanel />
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Flex>
    <Box col={12} ml={2} mt={1}>
      <Heading level={4}>
        Legacy Tools
      </Heading>
      <Text>
        <Link to="/simbot/stats">
          Stat Weights
        </Link>
      </Text>
      <Text>
        <Link to="/simbot/gear">
          Gear Compare
        </Link>
      </Text>
    </Box>

    <Box mt={5}>
      <News />
    </Box>
  </Box>
);

export default Home;
